"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionnaireFormDefinition = void 0;
const FormHandlerPluginBase_1 = require("../../PluginType/FormHandler/FormHandlerPluginBase");
const FormHandlerPluginDefinition_1 = require("../../PluginType/FormHandler/FormHandlerPluginDefinition");
const WidgetError_1 = require("auto-widget-framework/src/Error/WidgetError");
const FormValidationRendererTypes_1 = require("../../Enum/FormValidationRendererTypes");
const FormValidatorTypes_1 = require("../../Enum/FormValidatorTypes");
const configs_1 = require("../../configs/configs");
const TriggerFieldFormExtension_1 = require("../FormExtension/TriggerFieldFormExtension");
class QuestionnaireForm extends FormHandlerPluginBase_1.default {
    constructor(definition, formElement, formValidatorFactory, formValidationRendererFactory, formValuesToObjectTransformer, scrollInView) {
        super(definition, formElement, formValidatorFactory, formValidationRendererFactory, scrollInView);
        this.formValuesToObjectTransformer = formValuesToObjectTransformer;
    }
    /**
     * @inheritDoc
     */
    static create(definition, formElement, container) {
        return new this(definition, formElement, container.get("factory.form_validator"), container.get("factory.form_validation_renderer"), container.get("transformer.form_values_to_object"), container.get("scroll_in_view"));
    }
    /**
     * @inheritDoc
     */
    getFormValidationRenderer() {
        return this.formValidationRendererFactory.create(FormValidationRendererTypes_1.FormValidationRendererTypes.QUESTIONNAIRE, {
            form: this.getFormElement(),
            questionnaire: this.questionnaires
        });
    }
    /**
     * @inheritDoc
     */
    getFormValidator() {
        return this.formValidatorFactory.create(FormValidatorTypes_1.FormValidatorTypes.QUESTIONNAIRE, {
            form: this.getFormElement(),
            questionnaire: this.questionnaires
        });
    }
    /**
     * @inheritDoc
     */
    initialize(questionnaires) {
        if (!questionnaires) {
            throw new WidgetError_1.default(`Questionnaire required for questionnaire form initialization.`);
        }
        this.questionnaires = questionnaires;
        super.initialize();
        this.registerDateMaxlengthTrimmer();
        return this;
    }
    /**
     * @inheritDoc
     */
    getValidationConfig() {
        return configs_1.configs.validationsForSteps.car_condition_page;
    }
    /**
     * @inheritDoc
     */
    getValues() {
        let values = this.formValuesToObjectTransformer.to(this.getFormElement());
        return values;
    }
    /**
     * @inheritDoc
     */
    getValue(inputName) {
        return this.getValues()[inputName];
    }
    /**
     * Watch the date inputs that need to be trimmed.
     */
    registerDateMaxlengthTrimmer() {
        const dateFields = this.getFormElement().querySelectorAll('input[type="number"]');
        for (let i = 0; i < dateFields.length; i++) {
            if (dateFields[i].hasAttribute("maxlength")) {
                dateFields[i].addEventListener('input', () => {
                    this.controlMaxLength(dateFields[i]);
                });
            }
        }
    }
    /*
     * Removes extra characters from input if they exceed maxlenght.
     */
    controlMaxLength(input) {
        if (input.hasAttribute("maxlength")) {
            input.value = input.value.substr(0, input.getAttribute("maxlength"));
        }
    }
    /**
     * @inheritDoc
     */
    submit(values, action = "default") {
        return Promise.resolve().then(() => {
            return values;
        });
    }
}
exports.default = QuestionnaireForm;
exports.QuestionnaireFormDefinition = new FormHandlerPluginDefinition_1.default({
    id: "questionnaire",
    class: QuestionnaireForm,
    extensions: [TriggerFieldFormExtension_1.TriggerFieldFormExtensionDefinition.getId()]
});
